'use client'

import { Tag } from '@/components/ui/tag'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { sortedAttributeCardsUnderwear } from '../../constants'
import { useCollectionStore } from '../../store/collection-store'
import { updateUrl } from '../../utils/filter-utils'

type Props = {
  imageUrl: string
  imageHoverUrl?: string
  title: string
  description: string
  productCount?: number
  filterValue: string
  filterKey: string
  activeKey?: string
  isUnderWare?: boolean
  onChangeFilter?: (value: string) => void
  hasConcatActive?: boolean
  hasConcatParent?: boolean
}

export const FilterCard = ({
  imageUrl,
  imageHoverUrl,
  title,
  description,
  productCount,
  filterValue,
  filterKey,
  isUnderWare,
  onChangeFilter,
  hasConcatActive,
  hasConcatParent,
}: Props) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const setFilter = useCollectionStore((s) => s.setFilter)
  const router = useRouter()

  const isActive =
    searchParams.get(filterKey) === filterValue ||
    (isUnderWare && pathname.includes(filterValue))

  const handleClick = () => {
    const params = new URLSearchParams(searchParams.toString())

    if (isActive) {
      params.delete(filterKey)
      setFilter({})
    } else {
      params.set(filterKey, filterValue)
      setFilter({
        [filterKey]: filterValue,
      })
    }

    // const queryString = params.toString()
    // const url = queryString ? `${pathname}?${queryString}` : pathname
    const urlUnderWare = `/collection/quan-lot-nam-${filterValue}`
    // updateUrl(
    //   isUnderWare ? urlUnderWare : url,
    //   { scroll: false },
    //   isUnderWare ? router : undefined
    // )

    if (isUnderWare) {
      updateUrl(urlUnderWare, { scroll: false }, router)
    } else {
      onChangeFilter?.(isActive || hasConcatActive ? '' : filterValue)
    }

    document.getElementById('collection-listing')?.scrollIntoView({
      behavior: 'smooth',
    })
  }

  const isActiveUnderWare = sortedAttributeCardsUnderwear.find((item) =>
    pathname.includes(item.seo_alias)
  )
  const shouldBeDimmed =
    (!isActive &&
      (searchParams.get(filterKey) ||
        (isUnderWare &&
          !pathname.includes(filterValue) &&
          isActiveUnderWare))) ||
    (hasConcatParent && !hasConcatActive && !isUnderWare)

  return (
    <figure className='cursor-pointer' onClick={handleClick}>
      <picture
        className={cn(
          'group block overflow-hidden rounded-xl',
          shouldBeDimmed && 'opacity-40'
        )}
      >
        <Image
          src={ImageHelper.getImageUrl(imageUrl, 'l')}
          alt='image product'
          width={225}
          height={334}
          className={cn(
            'aspect-[225/334] min-h-[180px] w-auto object-cover transition-all duration-300',
            imageHoverUrl && 'group-hover:hidden'
          )}
        />
        {imageHoverUrl && (
          <Image
            src={ImageHelper.getImageUrl(imageHoverUrl || '', 'l')}
            alt='image product'
            width={225}
            height={334}
            className='hidden aspect-[225/334] w-auto object-cover transition-all duration-300 group-hover:block'
          />
        )}
      </picture>
      <figcaption className='mt-2'>
        <p
          className={cn(
            'line-clamp-1 font-sans text-sm font-medium leading-4.5 text-neutral-900 lg:text-lg lg:leading-5.5',
            isActive && 'text-primary'
          )}
        >
          {title}
        </p>
        <p className='line-clamp-2 font-sans text-xs leading-3.5 text-neutral-400 lg:text-sm lg:leading-4.5'>
          {description}
        </p>
        {productCount && productCount > 0 && (
          <Tag
            title={`${productCount} sản phẩm`}
            className='mt-2 h-[23px] rounded border-neutral-300 px-2 py-1 text-xs font-normal leading-3 text-neutral-300 hover:border-neutral-400 lg:h-6.5 lg:text-sm lg:leading-4.5'
          />
        )}
      </figcaption>
    </figure>
  )
}
